import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../../base/base.component';

import { WizardService } from '../../../services/wizard/wizard.service';
import { ErrorService } from '../../../services/error/error.service';
import { EventService } from '../../../services/event/event.service';
import { DateRange } from 'common-lib';

import moment_ from 'moment';
const moment = moment_;
import * as _ from 'lodash';
declare var $: any;
@Component({
    selector: 'wizard-quick-dates',
    templateUrl: './quick-dates.component.html',
    styleUrls: ['./quick-dates.component.scss', '../../form-styles.scss']
})
export class QuickDatesComponent extends BaseComponent implements OnInit {
    @ViewChild('buttonDropdown') buttonDropdown: ElementRef;
    public intervals: {
        label: string;
        value?: string;
    }[] = [
        {
            label: 'This Week',
            value: 'this week'
        },
        {
            label: 'Next Week',
            value: 'next week'
        },
        {
            label: 'Next 3 Weeks',
            value: 'next 3 weeks'
        }
    ];

    public additionalIntervals = [
        {
            label: 'Next 3 Weeks',
            value: 'next 3 weeks'
        },
        {
            label: 'Tomorrow'
        },
        {
            label: 'This Month'
        },
        {
            label: 'Anytime',
            value: 'next three months'
        }
    ];

    constructor(
        public wizardService: WizardService,
        private errorService: ErrorService,
        private eventService: EventService
    ) {
        super();
    }

    ngOnInit() {
        this.wizardService.updateQuickDates(null); // we do this to reset the buttons if users nav back and forth
    }

    ngAfterViewInit() {
        if (this.buttonDropdown) $(this.buttonDropdown.nativeElement).dropdown();
    }

    handleSelectInterval(interval: { label: string; value?: string }) {
        const taskId = this.wizardService.options.taskId;
        const payload = _.pickBy(
            {
                dateRange: {
                    type: 'text',
                    text: interval.value || interval.label
                },
                taskId,
                type: this.wizardService.meetingType
            },
            _.identity
        ) as { dateRange: DateRange; type: string; taskId?: string };

        /** Sends human-readable queries to be interpreted by our NLP algorithm */
        this.eventService.requestDates(payload).subscribe(
            (response) => {
                const dateRange = {
                    label: interval.label,
                    start: moment(response.data.dateStart),
                    end: moment(response.data.dateEnd)
                };
                this.wizardService.updateQuickDates(dateRange);
                this.eventService.clearErrorMessage('availability');
            },
            (error) => this.errorService.setServerError(error)
        );
    }
}
